import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

const fabVariants = cva(
  "floating-action-button fixed z-50 transition-all duration-240 shadow-lg hover:shadow-xl touch-manipulation md:hidden",
  {
    variants: {
      position: {
        "bottom-right":
          "right-[calc(env(safe-area-inset-right)+clamp(1rem,4vw,1.5rem))] bottom-[calc(env(safe-area-inset-bottom)+16px)]",
        "bottom-left":
          "left-[calc(env(safe-area-inset-left)+clamp(1rem,4vw,1.5rem))] bottom-[calc(env(safe-area-inset-bottom)+16px)]",
        "bottom-center":
          "left-1/2 bottom-[calc(env(safe-area-inset-bottom)+16px)] -translate-x-1/2",
      },
      size: {
        sm: "h-14 w-14 sm:h-12 sm:w-12",
        default: "h-16 w-16 sm:h-14 sm:w-14",
        lg: "h-18 w-18 sm:h-16 sm:w-16",
      },
    },
    defaultVariants: {
      position: "bottom-right",
      size: "default",
    },
  }
);

export interface FloatingActionButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof fabVariants> {
  asChild?: boolean;
}

const FloatingActionButton = React.forwardRef<
  HTMLButtonElement,
  FloatingActionButtonProps
>(({ className, position, size, ...props }, ref) => (
  <Button
    data-overlay-suppressable="true"
    className={cn(fabVariants({ position, size }), "rounded-full", className)}
    ref={ref}
    {...props}
  />
));

FloatingActionButton.displayName = "FloatingActionButton";

export { FloatingActionButton, fabVariants };
